import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

export const SingleQuerySchema = z.object({
  checked: z.boolean(),
  grouped: z.string().optional(),
  action: z
    .object(
      {
        value: z.string().min(1, { message: "Work Related is required" }),
        label: z.string(),
      },
      {
        message: "Work Related is required",
      },
    )
    ?.optional(),
  itemType: z.object(
    {
      value: z.string().min(1, { message: "Item Type is required" }),
      label: z.string(),
    },
    {
      message: "Item Type is required",
    },
  ),
  field: z.object(
    {
      value: z.string().min(1, { message: "Field is required" }),
      label: z.string(),
      data: z
        .object({
          dateTime: z.string().nullable(),
          fieldType: z.string().nullable().optional(),
          label: z.string(),
          relatedEntityType: z.string().nullable().optional(),
          value: z
            .array(
              z.object({
                label: z.string(),
                value: z.string(),
              }),
            )
            .nullable(),
        })
        .optional(),
    },
    {
      message: "Field is required",
    },
  ),
  operator: z.object(
    {
      value: z.string().min(1, { message: "Operator is required" }),
      label: z.string(),
    },
    {
      message: "Operator is required",
    },
  ),
  value: z.union([
    z.string({ required_error: "Value is required" }).min(1, {
      message: "",
    }),
    z.date({ required_error: "Date is required" }),
    z.object(
      {
        value: z.string().min(1, { message: "Value is required" }),
        label: z.string(),
      },
      {
        message: "",
      },
    ),
    z.array(
      z.object({
        value: z.string().min(1, { message: "Value is required" }),
        label: z.string(),
      })
    ),
  ]),
  queryData: z
    .array(
      z.object(
        {
          itemType: z.string().nullable(),
          data: z.array(
            z.object({
              dateTime: z.string().nullable(),
              fieldType: z.string(),
              label: z.string(),
              relatedEntityType: z.string().nullable(),
              value: z
                .array(
                  z.object({
                    label: z.string(),
                    value: z.string(),
                  }),
                )
                .nullable(),
            }),
          ),
        },
        {
          message: "Work Related is required",
        },
      ),
    )
    ?.optional(),
});

export const QuerySchema = z.object({
  checked: z.boolean(),
  grouped: z.string().optional(),
  action: z
    .object(
      {
        value: z.string().min(1, { message: "Work Related is required" }),
        label: z.string(),
      },
      {
        message: "Work Related is required",
      },
    )
    ?.optional(),
  itemType: z.object(
    {
      value: z.string().min(1, { message: "Item Type is required" }),
      label: z.string(),
    },
    {
      message: "Item Type is required",
    },
  ),
  field: z.object(
    {
      value: z.string().min(1, { message: "Field is required" }),
      label: z.string(),
      data: z
        .object({
          dateTime: z.string().nullable(),
          fieldType: z.string().nullable().optional(),
          label: z.string(),
          relatedEntityType: z.string().nullable().optional(),
          value: z
            .array(
              z.object({
                label: z.string(),
                value: z.string(),
              }),
            )
            .nullable(),
        })
        .optional(),
    },
    {
      message: "Field is required",
    },
  ),
  operator: z.object(
    {
      value: z.string().min(1, { message: "Operator is required" }),
      label: z.string(),
    },
    {
      message: "Operator is required",
    },
  ),
  value: z.union([
    z.string({ required_error: "Value is required" }).min(1, {
      message: "",
    }),
    z.date({ required_error: "Date is required" }),
    z.object(
      {
        value: z.string().min(1, { message: "Value is required" }),
        label: z.string(),
      },
      {
        message: "",
      },
    ),
    z.array(
      z.object({
        value: z.string().min(1, { message: "Value is required" }),
        label: z.string(),
      })
    ),
  ]),
  queryData: z
    .array(
      z.object(
        {
          itemType: z.string().nullable(),
          data: z.array(
            z.object({
              dateTime: z.string().nullable(),
              fieldType: z.string(),
              label: z.string(),
              relatedEntityType: z.string().nullable(),
              value: z
                .array(
                  z.object({
                    label: z.string(),
                    value: z.string(),
                  }),
                )
                .nullable(),
            }),
          ),
        },
        {
          message: "Work Related is required",
        },
      ),
    )
    ?.optional(),
  groupedClauses: z.array(SingleQuerySchema)?.optional(),
});
export const CreateQuerySchema = z.object({
  queries: z.array(QuerySchema),
});

export const SaveQueryModalSchema = z.object({
  title: z.string().min(1, { message: "Title is required" }),
});

export type SaveQueryModalDto = z.infer<typeof SaveQueryModalSchema>;
export type QueryRequestDto = z.infer<typeof CreateQuerySchema>;
export type SingleQueryClauseDto = z.infer<typeof SingleQuerySchema>;
export type GroupedQueryClauseDto = z.infer<typeof QuerySchema>;
export const CreateQueryValidator = zodResolver(CreateQuerySchema);
export const SaveQueryValidator = zodResolver(SaveQueryModalSchema);
